
module.exports = {
    messages: {
        de: {
            topNav: {
                archives: "Archive",
                digital: "Digital",
                editions: "Edition",
                manuscripts: "Manuskripte",
                persons: "Personen",
                projects: "Stücke",
                translations: "Übersetzungen",
                wb: "Walter Benjamin"
            }
        },
        en: {
            topNav: {
                archives: "Archives",
                digital: "Digital",
                editions: "Edition",
                manuscripts: "Manuscripts",
                persons: "Names",
                projects: "Projects",
                translations: "Translations",
                wb: "Walter Benjamin"
            }
        },
        fr: {
            topNav: {
                archives: "Archives",
                digital: "en édition numérique",
                editions: "Édition",
                manuscripts: "Manuscrits",
                persons: "Personnes",
                projects: "Titres",//"Projets",
                translations: "Traductions",
                wb: "Walter Benjamin"
            }
        }
    }
}
